import React from "react";

export const ForgotModalIcon = () => {
  return (
    <svg width="88.02" height="79.594" viewBox="0 0 88.02 79.594">
      <defs>
        <clipPath id="appz0db74a">
          <path style={{ fill: "none" }} d="M0 0h88.02v79.594H0z" />
        </clipPath>
      </defs>
      <g>
        <g>
          <g>
            <path
              d="M262.2 491.854V507.2a3.839 3.839 0 0 1-3.838 3.838h-28.145a3.839 3.839 0 0 1-3.838-3.838v-15.346a3.839 3.839 0 0 1 3.838-3.838h1.919v-5.757a12.153 12.153 0 0 1 24.306 0v5.757h1.919a3.839 3.839 0 0 1 3.839 3.838zm-12.153-9.595a5.757 5.757 0 0 0-11.513 0v5.757h11.513z"
              transform="translate(-204.743 -453.136)"
              style={{
                stroke: "#000",
                strokeWidth: "1.2px",
                fill: "none",
              }}
            />
          </g>
        </g>
        <g>
          <g style={{ clipPath: "url(#appz0db74a)" }}>
            <path d="M78.456 38.573 76.1 36.6l-6.521-5.47a2.088 2.088 0 0 0-.269-.208.544.544 0 0 0-.682.108.514.514 0 0 0-.026.684 1.793 1.793 0 0 0 .268.26q4.854 4.068 9.709 8.132a1.145 1.145 0 0 0 .31.2.557.557 0 0 0 .652-.241c.375-.441.745-.886 1.117-1.329l7.026-8.37a3.357 3.357 0 0 0 .234-.292.543.543 0 0 0-.8-.716 2.42 2.42 0 0 0-.276.3q-3.442 4.113-6.89 8.222c-.1.12-.2.237-.363.422-.021-.21-.034-.338-.045-.467-.09-1.017-.161-2.035-.274-3.049a35.637 35.637 0 0 0-1.128-5.63A39.873 39.873 0 0 0 47.375.734a38.889 38.889 0 0 0-9.45-.687A39.774 39.774 0 0 0 .306 34.914a38.791 38.791 0 0 0-.243 7.1 39.807 39.807 0 0 0 26.267 35.23 40.226 40.226 0 0 0 7.17 1.846 39.724 39.724 0 0 0 8.176.464 38.715 38.715 0 0 0 5.438-.635A39.81 39.81 0 0 0 78.1 50.658c.047-.164.1-.326.138-.491a.553.553 0 1 0-1.06-.3c-.125.4-.231.807-.353 1.208a38.651 38.651 0 0 1-31.342 27 37.96 37.96 0 0 1-7.435.373A38.653 38.653 0 0 1 1.33 43.158a37.716 37.716 0 0 1-.038-6.189A38.657 38.657 0 0 1 32.01 2a40.342 40.342 0 0 1 6.071-.761 35.92 35.92 0 0 1 5.1.1 38.648 38.648 0 0 1 34.228 29.4 37.789 37.789 0 0 1 1.055 7.6c0 .052 0 .105-.01.228" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ResetModalIcon = () => {
  let style = {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1.3px",
  };
  let style2 = {
    stroke: "#000",
    strokeWidth: "1.3px",
    fill: "none",
  };
  return (
    <svg width="131.806" height="91.493" viewBox="0 0 131.806 91.493">
      <g>
        <g>
          <g>
            <path
              d="M151.57 290.953h-36.73v-10.664a10.664 10.664 0 0 1 21.327 0v.015h11.849v-.015a22.512 22.512 0 0 0-45.025 0v10.664h-3.555a7.111 7.111 0 0 0-7.109 7.109V326.5a7.111 7.111 0 0 0 7.109 7.109h52.134a7.111 7.111 0 0 0 7.109-7.109v-28.438a7.111 7.111 0 0 0-7.109-7.109z"
              transform="translate(-91.677 -257.127)"
              style={style2}
            />
            <path
              transform="translate(44.49 33.811)"
              style={style2}
              d="M0 0h11.849v.015H0z"
            />
          </g>
          <path
            d="M260.433 410.638a13.046 13.046 0 0 0 6.486-11.8q.011-3.108.013-6.217v-.755q0-3.223-.026-6.446a15.6 15.6 0 0 0-.354-3.37 12.962 12.962 0 0 0-12.974-10.274q-22.3-.014-44.6 0h-10.44c-3.935 0-7.873.073-11.807 0h-2.567a13.263 13.263 0 0 0-12.614 13.711v14.606a1.775 1.775 0 0 1 .142.589 13.17 13.17 0 0 0 12.678 11.756q17.362.025 34.724.02h.389q17.341 0 34.682-.016a11.89 11.89 0 0 0 6.268-1.804zm-24.384-5.554c-5.593 0-11.185.024-16.778.024h-16.882q-8.441 0-16.882.016c-2.678.007-4.781-.921-6-3.377a5.652 5.652 0 0 1-.594-2.36q-.082-7.276-.019-14.554a5.907 5.907 0 0 1 5.592-5.8c.377-.024.757-.02 1.135-.02h67.219c4.406 0 6.815 2.413 6.816 6.823 0 4.163-.116 8.331.035 12.489.132 3.626-2.286 6.877-6.865 6.83-5.591-.067-11.184-.076-16.777-.071z"
            transform="translate(-138.125 -323.964)"
            style={{
              stroke: "#fff",
              strokeLinejoin: "round",
              strokeWidth: "6px",
            }}
          />
          <path
            d="M269.963 408.66c-.151-4.158-.034-8.325-.035-12.489 0-4.41-2.411-6.822-6.816-6.823H195.9c-.379 0-.758 0-1.135.02a5.906 5.906 0 0 0-5.591 5.8q-.065 7.276.019 14.553a5.653 5.653 0 0 0 .594 2.361c1.217 2.456 3.32 3.383 6 3.377q8.441-.021 16.882-.016t16.882 0c5.593 0 11.185-.019 16.779-.024s11.185 0 16.777.061c4.57.057 6.988-3.194 6.856-6.82zm-67.471-.44a5.895 5.895 0 0 1-.041-11.79 5.95 5.95 0 0 1 5.921 5.888 5.883 5.883 0 0 1-5.88 5.902zm17.982 0a5.894 5.894 0 0 1-5.882-5.836 5.959 5.959 0 0 1 5.89-5.956 5.882 5.882 0 0 1 5.9 5.913 5.818 5.818 0 0 1-5.908 5.881zm18.051 0a5.866 5.866 0 0 1-5.874-5.923 5.9 5.9 0 1 1 5.874 5.923zm18.117 0a5.822 5.822 0 0 1-5.94-5.844 5.891 5.891 0 1 1 5.94 5.844z"
            transform="translate(-148.44 -334.268)"
            style={{ fill: "#fff" }}
          />
          <path
            d="M300.629 406.3a5.925 5.925 0 0 0-5.857 5.867 5.9 5.9 0 1 0 11.8.033 5.955 5.955 0 0 0-5.943-5.9z"
            transform="translate(-210.373 -344.21)"
            style={style}
          />
          <path
            d="M256.553 406.693a5.959 5.959 0 0 0-5.89 5.956 5.894 5.894 0 0 0 5.882 5.836 5.818 5.818 0 0 0 5.9-5.879 5.882 5.882 0 0 0-5.892-5.913z"
            transform="translate(-184.51 -344.437)"
            style={style}
          />
          <path
            d="M343.814 406.3a5.883 5.883 0 0 0-5.865 5.946 5.891 5.891 0 0 0 11.782-.024 5.942 5.942 0 0 0-5.917-5.922z"
            transform="translate(-235.688 -344.209)"
            style={style}
          />
          <path
            d="M213.187 406.695a5.9 5.9 0 1 0 5.921 5.888 5.9 5.9 0 0 0-5.921-5.888z"
            transform="translate(-159.104 -344.438)"
            style={style}
          />
        </g>
      </g>
    </svg>
  );
};

export const OpenEyeIcon = () => {
  return (
    <svg width="27.83" height="18.555">
      <g>
        <path
          d="M65.29 96.524a1.556 1.556 0 0 1-.167.7 15.311 15.311 0 0 1-27.5 0 1.565 1.565 0 0 1-.167-.707 1.549 1.549 0 0 1 .167-.7 15.311 15.311 0 0 1 27.5 0 1.575 1.575 0 0 1 .167.707zm-2.418 0a12.978 12.978 0 0 0-22.994 0 12.978 12.978 0 0 0 22.994 0zm-11.48-5.411a5.392 5.392 0 1 1-5.187 3.9 2.668 2.668 0 0 0 1.3.35 2.707 2.707 0 0 0 2.706-2.706 2.666 2.666 0 0 0-.35-1.3 5.314 5.314 0 0 1 1.51-.242z"
          style={{ fill: "#797979" }}
          transform="translate(-37.46 -87.246)"
        />
      </g>
    </svg>
  );
};

export const ClosedEyeIcon = () => {
  return (
    <svg width="27.835" height="22.268" viewBox="0 0 27.835 22.268">
      <path
        d="M235.956 131.128a.7.7 0 0 1-.152.435l-.435.544a.7.7 0 0 1-.978.109l-26.008-20.333a.7.7 0 0 1-.108-.978l.435-.544a.7.7 0 0 1 .978-.109l26.008 20.332a.7.7 0 0 1 .26.544zm-11.385-3.939 2.018 1.577a13.463 13.463 0 0 1-4.55.818 13.948 13.948 0 0 1-12.373-7.715 1.4 1.4 0 0 1 0-1.269 14.448 14.448 0 0 1 2.3-3.266l1.642 1.283a12.367 12.367 0 0 0-1.917 2.618 11.832 11.832 0 0 0 10.348 6.263 11.446 11.446 0 0 0 2.532-.309zm-2.533-1.084a4.859 4.859 0 0 1-4.853-4.69l5.863 4.585a4.934 4.934 0 0 1-1.01.1zm-2.533-10.825-2.018-1.578a13.427 13.427 0 0 1 4.55-.818 13.954 13.954 0 0 1 12.376 7.715 1.41 1.41 0 0 1 .15.636 1.393 1.393 0 0 1-.15.633 14.485 14.485 0 0 1-2.3 3.268l-1.64-1.283a12.407 12.407 0 0 0 1.913-2.619 11.832 11.832 0 0 0-10.348-6.263 11.392 11.392 0 0 0-2.532.309zm2.533 1.083a4.858 4.858 0 0 1 4.853 4.691l-5.862-4.583a4.9 4.9 0 0 1 1.009-.108z"
        transform="translate(-208.121 -110.1)"
        style={{ fill: "#797979" }}
      />
    </svg>
  );
};

export const ArrowIcon = () => {
  return (
    <svg width="73.298" height="73.308" viewBox="0 0 73.298 73.308">
      <g>
        <g>
          <path
            d="M221.872 74.385q-5.435 3.1-10.87 6.206c-4.749 2.714-9.508 5.409-14.237 8.158a3.4 3.4 0 0 1-4.008-.139c-5.458-3.695-10.951-7.337-16.437-10.99a3.057 3.057 0 0 1-1.6-2.533 2.767 2.767 0 0 1 2.163-2.774c2.26-.762 4.526-1.506 6.787-2.261q28.994-9.678 57.993-19.339a4.654 4.654 0 0 1 2.175-.264c1.784.317 2.58 1.977 1.96 3.87-.788 2.4-1.6 4.8-2.4 7.2q-9.587 28.765-19.166 57.532a3.3 3.3 0 0 1-2.011 2.5 2.877 2.877 0 0 1-3.429-1.438q-3.733-5.583-7.456-11.173c-1.2-1.8-2.372-3.621-3.613-5.392a3.239 3.239 0 0 1-.139-3.814q6.98-12.16 13.917-24.345c.168-.294.332-.592.5-.888z"
            transform="translate(-173.718 -49.404)"
            style={{ fill: "none", stroke: "#000", strokeWidth: "2px" }}
          />
        </g>
      </g>
    </svg>
  );
};

export const MountainIcon = () => {
  let fillNone = {
    fill: "none",
  };
  let fillTeal = {
    fill: "#2c9087",
  };
  let style = {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    fill: "#6cbcb4",
    stroke: "#fff",
  };
  return (
    <svg width="160.929" height="160.283" viewBox="0 0 160.929 160.283">
      <g>
        <g>
          <g>
            <g>
              <path d="M86.601 60.689z" />
              <path
                d="M225.744 395.47a7.955 7.955 0 0 0 3.955-7.193q.007-1.9.008-3.791v-.46q0-1.965-.016-3.93a9.514 9.514 0 0 0-.216-2.055 7.9 7.9 0 0 0-7.911-6.264q-13.6-.008-27.2 0h-6.363c-2.4 0-4.8.044-7.2 0h-1.565a8.087 8.087 0 0 0-7.691 8.36v8.905a1.083 1.083 0 0 1 .087.359 8.03 8.03 0 0 0 7.73 7.168q10.586.015 21.172.012h.237q10.573 0 21.147-.01a7.25 7.25 0 0 0 3.826-1.101zm-14.867-3.386c-3.41 0-6.82.015-10.23.015h-10.293q-5.147 0-10.293.01a3.691 3.691 0 0 1-3.657-2.059 3.446 3.446 0 0 1-.362-1.439q-.05-4.436-.012-8.874a3.6 3.6 0 0 1 3.41-3.539c.23-.015.461-.012.692-.012h40.983c2.686 0 4.155 1.471 4.156 4.16 0 2.539-.071 5.08.021 7.615a3.887 3.887 0 0 1-4.186 4.165c-3.406-.04-6.819-.045-10.23-.043z"
                transform="translate(-119.627 -335.874)"
                style={{
                  strokeWidth: "3.5px",
                  stroke: "#fff",
                  fill: "#2c9087",
                }}
              />
              <path
                d="M298.343 406.3a3.613 3.613 0 0 0-3.571 3.577 3.6 3.6 0 1 0 7.193.02 3.631 3.631 0 0 0-3.622-3.597z"
                transform="translate(-211.768 -361.695)"
                style={fillTeal}
              />
              <path
                d="M254.254 406.693a3.633 3.633 0 0 0-3.591 3.631 3.593 3.593 0 0 0 3.586 3.558 3.548 3.548 0 0 0 3.6-3.585 3.586 3.586 0 0 0-3.595-3.604z"
                transform="translate(-178.784 -361.986)"
                style={fillTeal}
              />
              <path
                d="M341.525 406.3a3.587 3.587 0 0 0-3.576 3.625 3.592 3.592 0 0 0 7.184-.015 3.623 3.623 0 0 0-3.608-3.61z"
                transform="translate(-244.054 -361.695)"
                style={fillTeal}
              />
              <path
                d="M210.9 406.695a3.594 3.594 0 1 0 3.61 3.59 3.6 3.6 0 0 0-3.61-3.59z"
                transform="translate(-146.381 -361.987)"
                style={fillTeal}
              />
            </g>
          </g>
        </g>
        <g data-name="Group 12486">
          <g data-name="Group 12488">
            <path
              d="M223.382 347.508v-5.143h15.683c0 1.478.03 2.969-.031 4.457a.95.95 0 0 1-.654.657c-4.98.038-9.957.029-14.998.029z"
              transform="translate(-200.587 -291.458)"
              style={style}
            />
            <path
              d="M415 347.436h-15.569v-5.06H415z"
              transform="translate(-276.88 -291.463)"
              style={style}
            />
            <path
              d="m400.7 291.8 2.627 4.56-13.641 7.885-2.642-4.559z"
              transform="translate(-271.511 -269.547)"
              style={style}
            />
            <path
              d="m250.841 299.689-2.63 4.561-13.649-7.885 2.629-4.559z"
              transform="translate(-205.431 -269.548)"
              style={style}
            />
            <path
              d="m270.174 258.821 4.558-2.637 7.888 13.654-4.563 2.631z"
              transform="translate(-220.864 -254.11)"
              style={style}
            />
            <path
              d="m248.2 379.844 2.636 4.563-13.649 7.879-2.636-4.554z"
              transform="translate(-205.429 -307.7)"
              style={style}
            />
            <path
              d="m387.044 384.413 2.637-4.557 13.64 7.869-2.613 4.569z"
              transform="translate(-271.511 -307.705)"
              style={style}
            />
            <path
              d="m362.78 272.467-4.561-2.628 7.881-13.658 4.556 2.635z"
              transform="translate(-259.018 -254.109)"
              style={style}
            />
            <path
              d="M320.712 264.656V254.29h5.036v10.366z"
              transform="translate(-242.765 -253.29)"
              style={style}
            />
            <path
              d="m218.5 401.019 4.559-2.627 2.631 4.552-4.547 2.628z"
              transform="translate(-198.472 -315.738)"
              style={style}
            />
            <path
              d="m419.152 402.951 2.633-4.556 4.554 2.626-2.624 4.559z"
              transform="translate(-285.425 -315.739)"
              style={style}
            />
            <path
              d="m221.14 282.545 4.55 2.625-2.629 4.559-4.56-2.635z"
              transform="translate(-198.472 -265.535)"
              style={style}
            />
            <path
              d="M423.712 282.527c.92 1.6 1.757 3.05 2.629 4.561l-4.549 2.631-2.629-4.551z"
              transform="translate(-285.431 -265.527)"
              style={style}
            />
            <path
              d="M209.919 347.418h-4.991v-5.077h4.991z"
              transform="translate(-192.589 -291.448)"
              style={style}
            />
            <path
              d="M436.518 347.411v-5.055h5.036v5.055z"
              transform="translate(-292.952 -291.454)"
              style={style}
            />
          </g>
          <g data-name="Group 12485">
            <path
              d="M418.227 450.941a1.4 1.4 0 0 0 .1-1.206c-1.6-4.055-3.239-8.09-5.01-12.478l-5.686 12.464 5.764 6.006c1.646-1.614 3.276-3.165 4.832-4.786z"
              transform="translate(-280.432 -332.581)"
              style={fillNone}
            />
            <path
              d="M228.666 455.971c1.825-1.864 3.47-3.614 5.2-5.275a1.235 1.235 0 0 0 .275-1.7c-1.478-3.145-2.907-6.313-4.353-9.472l-1.032-2.256c-1.78 4.417-3.454 8.536-5.079 12.675a1.242 1.242 0 0 0 .226 1.064c1.526 1.654 3.107 3.254 4.763 4.964z"
              transform="translate(-200.695 -332.588)"
              style={fillNone}
            />
            <path
              d="m292.2 383.841-.017-.015h-6.446c2.035.032 4.098.015 6.463.015z"
              transform="translate(-227.609 -309.426)"
              style={fillNone}
            />
            <path
              d="M359.692 383.826h-6.576l-.024.021c2.467 0 4.548.028 6.6-.021z"
              transform="translate(-256.797 -309.426)"
              style={fillNone}
            />
            <path
              d="M291.515 401.948c1.466 1.184 2.9 2.412 4.345 3.619 3.106 2.588 6.214 5.174 9.357 7.79.406-.317.742-.565 1.062-.831q6.136-5.114 12.268-10.232c1.945-1.621 2.717-1.658 4.752-.218 2.307 1.632 4.6 3.281 6.908 4.914.27.191.577.33 1.074.611l-4.31-14.384h-43.426l-4.35 14.561c3-2.133 5.669-4.053 8.361-5.947 1.544-1.086 2.503-1.059 3.959.117z"
              transform="translate(-224.773 -313.496)"
              style={fillNone}
            />
            <path
              d="M411.893 474.763a2.8 2.8 0 0 1-4.349-.005c-1.614-1.585-3.18-3.218-4.771-4.826-.372-.376-.762-.736-1.234-1.19-.823 1.808-1.568 3.38-2.246 4.981a2.168 2.168 0 0 0-.147 1.34q3.486 11.81 7.07 23.591a1.415 1.415 0 0 0 1.058.776c7.3.045 14.606.034 22.128.034l-12.255-30.018c-1.879 1.907-3.538 3.64-5.254 5.317z"
              transform="translate(-276.733 -346.225)"
              style={fillNone}
            />
            <path
              d="M322.315 432.756c-1.243-4.445-3.216-7.766-7.259-10.041a84.976 84.976 0 0 1-7.374-5.188c-4.581 3.828-9.063 7.577-13.55 11.319-1.8 1.5-2.91 1.494-4.742-.029q-3.425-2.848-6.838-5.712-3.348-2.794-6.7-5.581c-3.952 2.824-7.808 5.533-11.6 8.331a4.1 4.1 0 0 0-1.375 1.984q-7.244 23.925-14.4 47.878c-.142.473-.236.96-.367 1.5h87.361c-.139-.522-.244-.969-.376-1.408-4.287-14.342-8.748-28.637-12.78-43.053z"
              transform="translate(-211.305 -324.029)"
              style={fillNone}
            />
            <path
              d="M228.042 474.2c-.757-1.745-1.578-3.463-2.359-5.153-1.926 1.86-3.761 3.609-5.571 5.386-2.038 2-3.28 2.025-5.267.036-1.558-1.559-3.1-3.131-4.836-4.882l-12.225 29.966h22.85a3.322 3.322 0 0 0 .276-.53q3.565-11.862 7.106-23.731a1.746 1.746 0 0 0 .026-1.092z"
              transform="translate(-189.493 -346.359)"
              style={fillNone}
            />
            <path
              d="M343.246 463.386c-5.079-12.114-9.981-24.3-14.952-36.461q-4.063-9.937-8.135-19.87c-.494-1.209-1.193-2.125-2.662-2.143a2.719 2.719 0 0 0-2.614 1.988c-.864 1.935-1.757 3.857-2.637 5.785l-7.834 17.162c-.192-.55-.324-.887-.428-1.233q-5.61-18.7-11.245-37.4l-.022.065-2.179-7.457h-3.148c-2.052.049-4.132.021-6.6.021l.024-.021h-31.742l.017.015c-2.365 0-4.429.018-6.463-.015h-3.274l-1.469 5.026a3.79 3.79 0 0 1-.108.465c-3.05 10.072-6.048 20.16-9.067 30.242-1.008 3.365-2.034 6.724-3.124 10.324-.338-.7-.566-1.153-.777-1.613-3.29-7.2-6.593-14.389-9.853-21.6a2.56 2.56 0 0 0-2.881-1.725c-1.473.167-1.963 1.3-2.435 2.454q-11.468 28.044-22.934 56.089c-1.158 2.833-.062 4.431 3.066 4.431q75.174.006 150.349.041c2.633.006 4.365-1.616 3.127-4.57zM317.382 414.1c1.771 4.387 3.414 8.423 5.01 12.478a1.4 1.4 0 0 1-.1 1.206c-1.557 1.621-3.186 3.173-4.832 4.786l-5.764-6.006zm-74.113-24.955h43.426l4.31 14.384c-.5-.28-.8-.42-1.074-.611-2.306-1.633-4.6-3.281-6.908-4.914-2.035-1.44-2.807-1.4-4.752.218q-6.137 5.112-12.268 10.232c-.32.266-.656.514-1.062.831-3.143-2.616-6.251-5.2-9.357-7.79-1.448-1.207-2.879-2.435-4.345-3.619s-2.414-1.2-3.959-.116c-2.692 1.894-5.365 3.813-8.361 5.947l4.35-14.56zm-35.791 37.639c1.626-4.139 3.3-8.258 5.079-12.675l1.032 2.256c1.447 3.159 2.876 6.327 4.353 9.472a1.235 1.235 0 0 1-.275 1.7c-1.731 1.661-3.375 3.411-5.2 5.275-1.656-1.711-3.237-3.31-4.764-4.959a1.242 1.242 0 0 1-.225-1.067zm8.16 35.838h-22.85l12.225-29.966c1.734 1.752 3.278 3.323 4.836 4.882 1.988 1.988 3.23 1.964 5.267-.036 1.809-1.776 3.645-3.526 5.571-5.386.782 1.69 1.6 3.408 2.359 5.153a1.746 1.746 0 0 1-.027 1.092q-3.534 11.87-7.106 23.731a3.324 3.324 0 0 1-.275.532zm5.67-.01c.131-.541.226-1.028.367-1.5q7.179-23.945 14.4-47.878a4.1 4.1 0 0 1 1.375-1.984c3.79-2.8 7.645-5.508 11.6-8.331q3.351 2.79 6.7 5.581 3.421 2.853 6.838 5.712c1.831 1.523 2.94 1.532 4.742.029 4.487-3.742 8.969-7.491 13.55-11.319a84.965 84.965 0 0 0 7.374 5.188c4.042 2.275 6.015 5.6 7.259 10.041 4.032 14.415 8.493 28.71 12.787 43.053.131.439.237.885.376 1.408zm93.73.017a1.415 1.415 0 0 1-1.058-.776q-3.594-11.778-7.07-23.591a2.168 2.168 0 0 1 .147-1.34c.677-1.6 1.423-3.173 2.246-4.981.473.454.862.814 1.234 1.19 1.591 1.608 3.157 3.241 4.771 4.826a2.8 2.8 0 0 0 4.349.005c1.715-1.676 3.375-3.409 5.254-5.316l12.255 30.018c-7.522.001-14.825.012-22.127-.033z"
              transform="translate(-184.497 -309.426)"
              style={{
                fill: "#6cbcb4",
                strokeWidth: "3.5px",
                stroke: "#fff",
              }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
